import { Component, Input, OnInit } from "@angular/core";
import { FlowNode } from "../chatbot-flow-component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { FFlowModule } from "@foblex/flow";
import { ButtonPadraoComponent } from "../../shared/components/button-padrao/button-padrao.component";
import { FormFieldComponent } from "../../shared/components/form-field/form-field.component";
import { SelectOneComponent } from "../../shared/components/select-one/select-one.component";
import { FormRequisicaoComponent } from "../cadastro-requisicao/form-requisicao.component";
import { CapturaEtapa } from "../../shared/model/etapa/etapa-captacao-model";
import { TipoEtapaCaptacaoEnum } from "../../shared/enum/tipo-etapa-captura-enum";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { FluxoSelect } from "../../shared/model/fluxo/fluxo-select-model";
import { VariavelSelect } from "../../shared/model/variavel/variavel-select.model";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-form-captura',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FFlowModule,
    FormRequisicaoComponent,
    FormFieldComponent,
    ButtonPadraoComponent,
    SelectOneComponent,
    MatSlideToggle,
    MatIcon
  ],
  templateUrl: './form-captura.component.html',
  styleUrls: ['./form-captura.component.css']
})
export class FormCapturaComponent implements OnInit {
  @Input() selectedNode: FlowNode | null = null;
  @Input() fluxosSelect: FluxoSelect[] = [];
  @Input() variaveisSelect: VariavelSelect[] = [];
  capturas: CapturaEtapa[] = [];
  TipoEtapaCaptacaoEnum = TipoEtapaCaptacaoEnum;
  variavelSelecionada: VariavelSelect | null = null;
  fluxoSelecionado: FluxoSelect | null = null;

  ngOnInit(): void {
    if (this.selectedNode?.capturas) {
      this.capturas = this.selectedNode.capturas;
    }
  }


  adicionarCaptura() {
    if (!this.selectedNode) return;

    const novaCaptura = new CapturaEtapa();
    novaCaptura.id = undefined;
    novaCaptura.etapaId = this.selectedNode.id ? Number(this.selectedNode.id) : undefined;
    novaCaptura.tipoCaptura = TipoEtapaCaptacaoEnum.PREENCHIMENTO;
    novaCaptura.valorCaptura = '';
    novaCaptura.fluxoEnvioId = undefined;
    novaCaptura.variavelSalvamentoId = undefined;

    this.selectedNode.capturas = this.selectedNode.capturas || [];
    this.selectedNode.capturas.push(novaCaptura);
  }

  removerCaptura(captura: CapturaEtapa){
    if (!this.selectedNode) return;
    const index = this.selectedNode.capturas?.indexOf(captura);
    if (index !== undefined && index !== -1) {
      this.selectedNode.capturas?.splice(index, 1);
    }
  }

  selecionarVariavel(event: any, captura: CapturaEtapa){
    if(event){
      captura.variavelSalvamentoId = event.id;
      this.variavelSelecionada = event;
    }
  }

  selecionarFluxo(event: any, captura: CapturaEtapa){
    if(event){
      captura.fluxoEnvioId = event.id;
      this.fluxoSelecionado = event;
    }
  }

  getVariavelSelecionada(captura: CapturaEtapa): VariavelSelect | null {
    return this.variaveisSelect.find(v => v.id === captura.variavelSalvamentoId) || null;
  }

  getFluxoSelecionado(captura: CapturaEtapa): FluxoSelect | null {
    return this.fluxosSelect.find(f => f.id === captura.fluxoEnvioId) || null;
  }

}
